import PropTypes from 'prop-types';
import { ChartSvg, CheckFileSvg, MinusSvg } from '../../assets/svgs';
import { Container, IconBox, Label, StatIcon, StatLabel, StatRow, StatValue, TopRow } from './dashboard-card-primary.style';

const DashboardCardPrimary = ({
    label,
    value,
    statsIcon,
    statValue = 0,
    statLabel,
    variant = "default",
    iconPrimary: Icon = CheckFileSvg,
}) => {
    const isNegative = parseFloat(statValue) < 0;

    return (
        <Container className='box-shadow'>
            <TopRow>
                <IconBox $variant={variant}>
                    <Icon />
                </IconBox>
                <Label>{label}</Label>
            </TopRow>
            <h2>{value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h2>
            <StatRow>
                {
                    statsIcon && (
                        <>
                            {
                                statValue && statValue !== 0 && statValue !== 0.00 ? (
                                    <StatIcon $downward={isNegative}>
                                        <ChartSvg />
                                    </StatIcon>
                                ) : (
                                    <StatIcon $downward={undefined}>
                                        <MinusSvg />
                                    </StatIcon>
                                )
                            }
                        </>
                    )
                }
                <StatValue $downward={statValue !== 0 && statValue !== 0.00 ? isNegative : undefined}>{statValue + '%'}</StatValue>
                {statLabel && <StatLabel>{statLabel}</StatLabel>}
            </StatRow>
        </Container>
    );
};


DashboardCardPrimary.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    statValue: PropTypes.any,
    statLabel: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'success', 'error']),
    statsIcon: PropTypes.bool,
    iconPrimary: PropTypes.elementType,
};

export default DashboardCardPrimary;
